import CryptoJS from "crypto-js";

export const lines = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 4],
  [0, 6],
  [6, 7],
  [7, 8],
  [8, 9],
  [14, 15],
  [15, 16],
  [18, 19],
  [19, 20],
  [14, 18],
  [0, 12],
  [12, 13],
  [13, 14],
  [13, 18],
  [16, 31],
  [20, 31],
];
export const handedness = {
  right: "rightHanded",
  left: "leftHanded",
};
export const RoleId = {
  4: "Coach",
  5: "Striker",
};
export const ROLE = {
  Coach: "Coach",
  Striker: "Striker",
};
export const handednessId = {
  2: "Right Handed",
  1: "Left Handed",
};
export const HANDEDNESS = {
  rightHanded: "Right Handed",
  leftHanded: "Left Handed",
};
export const GenderID = {
  1: "Male",
  2: "Female",
};
export const gender = {
  Male: "Male",
  Female: "Female",
};
export const PlanID = {
  1: "Free",
  2: "3 Months",
  3: "6 Months",
  4: "1 Year",
};

export const appColors = {
  yellow: "#f4b821",
  blue: "#006ab3",
  green: "#7bb728",
  darkYellow: "#B78E00",
  darkGreen: "#629220",
};

export const fullSwing = "full swing";
export const downTheLine = "DownTheLine";
export const ORIENTATION_ID = {
  downTheLine: 1,
  faceOn: 2,
};

export const MONTHS = {
  "1m": "1 Month",
  "3m": "3 Months",
  "6m": "6 Months",
  "12m": "12 Months",
};
export const SUBSCRIPTION_NAMES = {
  1: "Trial",
  3: "Basic",
  6: "Standard",
  12: "Premium",
};

export const ENVIORNMENTS = {
  LIVE: "live",
  SANDBOX: "sandbox",
  ENVIORNMENT: "enviornment",
};
export const REACT_APP_baseURL_old =
  "https://nwtgnbnkm4.execute-api.eu-central-1.amazonaws.com/dev";
export const REACT_APP_baseURL_old_sandbox =
  "https://nwtgnbnkm4.execute-api.eu-central-1.amazonaws.com/sandbox";

export const REACT_APP_BaseServerURL =
  "https://55chh4xpy0.execute-api.eu-central-1.amazonaws.com/default";
export const REACT_APP_BaseServerURL_SANDBOX =
  "https://55chh4xpy0.execute-api.eu-central-1.amazonaws.com/sandbox";

export const REACT_APP_AanlyticsURL =
  "https://bowg0wsg5k.execute-api.eu-central-1.amazonaws.com/prod/api/motion2coach/cv/user";
export const REACT_APP_AanlyticsURL_SANDBOX =
  "https://bowg0wsg5k.execute-api.eu-central-1.amazonaws.com/sandbox/api/motion2coach/cv/user";

export const REACT_APP_AanlyticsURL_web =
  "https://bowg0wsg5k.execute-api.eu-central-1.amazonaws.com/prod/api/motion2coach";
export const REACT_APP_AanlyticsURL_web_SANDBOX =
  "https://bowg0wsg5k.execute-api.eu-central-1.amazonaws.com/sandbox/api/motion2coach";

export const REACT_APP_baseURL = "https://api.motion2coach.com";
export const REACT_APP_baseURL_SANDBOX = "https://api.motion2coach.com/sandbox";

export const REACT_APP_GOLF_SOCKET_BASEURL = `wss://ze6rcccm44.execute-api.eu-central-1.amazonaws.com/dev/?key=dashboard`;
export const REACT_APP_GOLF_SOCKET_BASEURL_SANDBOX = `wss://ze6rcccm44.execute-api.eu-central-1.amazonaws.com/sandbox/?key=dashboard`;

export const REACT_APP_GOLF_SOCKET2_BASEURL =
  "wss://v4co9fgcy0.execute-api.eu-central-1.amazonaws.com/dev/?key=dashboard";
export const REACT_APP_GOLF_SOCKET2_BASEURL_SANDBOX =
  "wss://v4co9fgcy0.execute-api.eu-central-1.amazonaws.com/sandbox/?key=dashboard";

export function getCurrentEnviornment() {
  return sessionStorage.getItem(ENVIORNMENTS.ENVIORNMENT) || ENVIORNMENTS.LIVE;
}

export function getBaseUrlOldForEnviornment() {
  return getCurrentEnviornment() === ENVIORNMENTS.LIVE
    ? REACT_APP_baseURL_old
    : REACT_APP_baseURL_old_sandbox;
}
// export function getBaseUrlOldForEnviornment() {
//   return getCurrentEnviornment() === ENVIORNMENTS.LIVE
//     ? process.env.REACT_APP_baseURL_old
//     : process.env.REACT_APP_baseURL_old_sandbox;
// }

export function maskEmail(email) {
  const [localPart, domain] = email.split("@");
  if (localPart.length < 2) return "*".repeat(localPart.length) + "@" + domain;

  const visible = localPart.slice(0, 2);
  const masked = "*".repeat(localPart.length - 2);

  return visible + masked + "@" + domain;
}

export const localStorageLiveUserId = () => {
  return localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`);
};
export const localStorageSandboxUserId = () => {
  return localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`);
};
export const localStorageCurrentEnvUserId = () => {
  return localStorage.getItem(`${getCurrentEnviornment()}_userId`);
};

export function getInitialLetters(username) {
  if (!username) return;
  const result = username.trim().split(/\s+/).filter(Boolean);
  let firstLetter = "";
  let lastLetter = "";
  if (result.length > 0) {
    firstLetter = result[0][0];
  }
  if (result.length > 1) {
    lastLetter = result[result.length - 1][0];
  }

  return result.length > 0 ? (firstLetter + lastLetter).toUpperCase() : "";
}

export const decryptAES = ({ encryptedData, iv }) => {
  try {
    if (!encryptedData || !iv) {
      console.warn("Missing encryptedData or iv");
      return null;
    }

    const key = process.env.REACT_APP_encryption_key;

    if (!key) {
      console.warn("Missing encryption key in env");
      return null;
    }

    const parsedKey = CryptoJS.enc.Hex.parse(key);
    const parsedIv = CryptoJS.enc.Base64.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(encryptedData, parsedKey, {
      iv: parsedIv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const text = decrypted.toString(CryptoJS.enc.Utf8);

    if (!text || text.length === 0) {
      console.warn("Decryption failed: empty result (wrong key/iv)");
      return null;
    }

    try {
      return JSON.parse(text);
    } catch (jsonError) {
      console.warn("Decryption succeeded but JSON parsing failed");
      return null;
    }
  } catch (err) {
    console.error("Unexpected decrypt error:", err);
    return null;
  }
};
